import { matchRoutes, useLocation } from 'react-router';
import get from 'lodash/get';
import FlowRenderer from '../../common/FlowRenderer';
import { connect, useDispatch } from 'react-redux';
import { factoryManagementActions } from '../../store/reducers/factory-management';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { pageActions } from '../../store/reducers/page-actions';
import {useOutletContext } from 'react-router-dom';
// import { routePaths } from '../../utils/route-paths';
import isEmpty from 'lodash/isEmpty';

const FactoryFlow = ({ isFactoryLoading, selectedFactory, readonly, ontologyData, isUpdateFactorySuccess }: any) => {
  const routePaths: any = get(useOutletContext(), 'combinedRoutePaths', []);
  const dispatch = useDispatch();
  const { factoryId } = useParams();
  const { pathname } = useLocation();
  const outletData: any = get(useOutletContext(), 'outletData', {});
  const location = useLocation();
  const [pageData, setPageData] = useState<any>({});

  let matchedRoute: any = matchRoutes(routePaths, location);
  matchedRoute = !isEmpty(matchedRoute) ? matchedRoute[0] : {};

  useEffect(() => {
    if (!isEmpty(outletData)) {
      if (!isEmpty(outletData[matchedRoute.route.endPointPath.replace('/', '_')])) {
        const pageData = {
          ...outletData[matchedRoute.route.endPointPath.replace('/', '_')],
          machine_name: get(outletData.things_machines, 'entity_name', 'Machine'),
        };
        setPageData(pageData);
      } else {
        setPageData({ machine_name: get(outletData.things_machines, 'entity_name', 'Machine') });
      }
    }
  }, [outletData]);

  const factoryLabel = get(pageData, 'entity_name', ontologyData?.slice(-1)?.[0]?.level_name ?? 'Shop floor');
  const factoryTitle = get(outletData.site_factory, 'entity_name', factoryLabel);

  const onDataRequest = () => {
    const id: any = factoryId;
    dispatch(factoryManagementActions.getFactoryData({ factoryId: id, pageName: factoryTitle }));
  };

  useEffect(() => {
    const id: any = factoryId;
    if (id) {
      dispatch(factoryManagementActions.getFactoryData({ factoryId: id, pageName: factoryTitle }));
    }
    return () => {
      dispatch(factoryManagementActions.resetSelectedFactory());
    };
  }, [factoryId, isUpdateFactorySuccess]);

  useEffect(() => {
    if (pathname.length) {
      const pathnamesTemp: any = pathname.split('/').filter(Boolean);
      if (pathnamesTemp.length) {
        const pathnamesData: any = pathnamesTemp
          .filter((i: any, index: number) => index > 0)
          .map((item: any, index: number) => {
            if (index == 0) {
              // return { route: pathnamesTemp[0] + '/' + pathnamesTemp[1], pathName:get(outletData.site_factory,'page_name',item), navigate: true };
              const factoryLabel = get(
                outletData.site_factory,
                'page_name',
                ontologyData?.slice(-1)?.[0]?.level_name ?? 'Shop floor'
              );
              return { route: pathnamesTemp[0] + '/' + pathnamesTemp[1], pathName: factoryLabel, navigate: true };
            } else if (index == 1) {
              return { route: '', pathName: selectedFactory?.factory_name, navigate: false };
            } else {
              return { route: '', pathName: item, navigate: false };
            }
          });
        dispatch(pageActions.setPagePath(pathnamesData));
        return () => {
          const data: any = [];
          dispatch(pageActions.setPagePath(data));
        };
      }
    }
  }, [selectedFactory]);

  return (
    <FlowRenderer
      rowTitle={selectedFactory?.factory_name || ''}
      rowId={selectedFactory.factory_id || ''}
      onDataRequest={onDataRequest}
      selectedRow={selectedFactory}
      readonly={readonly}
      isSelectedRowLoading={isFactoryLoading}
      factoryLabel={factoryLabel}
    />
  );
};

const mapStateToProps = (state: any) => ({
  isFactoryLoading: state.factoryManagement.isFactoryLoading,
  selectedFactory: state.factoryManagement.selectedFactory,
  ontologyData: state.ontologyMaster.ontologyData,
  isUpdateFactorySuccess: state.factoryManagement.isUpdateFactorySuccess,
});

export default connect(mapStateToProps)(FactoryFlow);
